import React from "react";
import ApplicantCredentialTableRow from "../TableRows/ApplicantCredentialTableRow";
import { MdOutlineArrowBack } from "react-icons/md";
import { Link } from "react-router-dom";

function InterviewCredentialTable() {
  return (
    <div>
      <div className="mt-4">
        <div className="h-[6rem] shadow-md flex flex-col p-4 gap-4 mb-4 rounded-lg bg-white">
          <div className="">
            <Link to={"/dashboard/interviews"}>
              <MdOutlineArrowBack size="24px" />
            </Link>
          </div>

          <p className="text-xl">Credentials</p>
        </div>
        <ApplicantCredentialTableRow />
      </div>
    </div>
  );
}

export default InterviewCredentialTable;
